module.exports = __webpack_public_path__ + "static/media/xpax.32212c8b.png";